import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ViewListAsStudentComponent } from './view-list-as-student.component';

@NgModule({
  declarations: [ViewListAsStudentComponent],
  imports: [CommonModule, RouterModule],
  exports: [ViewListAsStudentComponent],
})
export class ViewListAsStudentModule {}
